const asset = (path) => new URL(path, import.meta.url).href
const publicAsset = (path) =>
  `${import.meta.env?.BASE_URL || '/ai-open-platform/'}${path}`
const apiAsset = (path) => {
  const baseUrl =
    import.meta.env?.VITE_API_BASE_URL || 'https://aimarket.quectel.com'
  return `${baseUrl.replace(/\/$/, '')}${path}`
}

export const demoImages = {
  hero: '',
  module: '',
  robot: '',
  robotCase1: '',
  robotCase2: '',
}

export const demoVideos = {
  memory: publicAsset('image/uniclaw-docs/memory.mp4'),
  chatDeviceBehavior: publicAsset(
    'image/uniclaw-docs/chat-device-behavior.mp4',
  ),
  skillExtension: publicAsset('image/uniclaw-docs/skill-extension.mp4'),
}

export const docImages = {
  dashboardChat: publicAsset('image/uniclaw-docs/dashboard-chat.png'),
  dashboardConfig: publicAsset('image/uniclaw-docs/dashboard-config.png'),
  uartConsole: publicAsset('image/uniclaw-docs/uart-console.jpg'),
  architecture: publicAsset('image/uniclaw-docs/architecture.png'),
  cliConfig: publicAsset('image/uniclaw-docs/cli-config.png'),
  cliChat: publicAsset('image/uniclaw-docs/cli-chat.png'),
  networkCheck: publicAsset('image/uniclaw-docs/network-check.png'),
  adbTerminal: publicAsset('image/uniclaw-docs/adb-terminal.png'),
  qflashOpen: publicAsset('image/uniclaw-docs/qflash-open.webp'),
  qflashLoadFirmware: publicAsset('image/uniclaw-docs/qflash-load-firmware.webp'),
  qflashFirmwarePackage: publicAsset('image/uniclaw-docs/qflash-firmware-package.png'),
  qflashBootMode: publicAsset('image/uniclaw-docs/qflash-boot-mode.webp'),
  qflashComPort: publicAsset('image/uniclaw-docs/qflash-com-port.webp'),
  qflashStartPass: publicAsset('image/uniclaw-docs/qflash-start-pass.webp'),
  qflashAtCheck: publicAsset('image/uniclaw-docs/qflash-at-check.png'),
}

export const productPages = [
  {
    no: '01',
    tag: 'Docs',
    title: '文档中心',
    desc: '快速开始、开发指南，资源下载，常见问题',
    cta: '查看文档',
    href: '/uniclaw/docs',
  },
  {
    no: '02',
    tag: 'Resource',
    title: '资源下载',
    desc: '查看 Linux 运行包、UniRTOS 固件包和常用命令，一键下载',
    cta: '查看资源',
    href: '/uniclaw/docs#downloads',
  },
  {
    no: '03',
    tag: 'Skills',
    title: 'Skills Hub',
    desc: '开放技能扩展生态，支持设备能力封装复用、自定义场景技能开发与发布管理',
    cta: '进入 Skills Hub',
    href: 'https://aipg.quectel.com/skills',
  },
]

export const iotStages = [
  {
    no: '01',
    title: '选择支持平台',
    desc: '当前支持基于 UniRTOS 的 MCU 平台以及 Quectel Pi H1 Linux 平台，包括 Pico 开发板、QuecDuino 开发板和 Quectel Pi H1 开发板',
  },
  {
    no: '02',
    title: '准备运行环境',
    desc: '根据目标平台完成运行环境部署：Quectel Pi H1 使用 Linux 运行环境，Pico 与 QuecDuino 使用 UniRTOS 固件运行环境',
  },
  {
    no: '03',
    title: '配置参数',
    desc: '配置大模型 API Key、消息通道、设备信息及运行参数，完成 Agent 能力初始化',
  },
  {
    no: '04',
    title: '运行并验证',
    desc: '通过 CLI、Dashboard或飞书、微信等IM平台完成首次对话，再根据场景进行扩展',
  },
]

export const capabilities = [
  {
    no: '01',
    icon: 'chat',
    title: '自然语言驱动',
    desc: '通过聊天对话即可定义设备行为，无需复杂代码开发',
    tag: 'Chat',
  },
  {
    no: '02',
    icon: 'heartbeat',
    title: 'Agent心跳机制',
    desc: 'AI自主检查／定时触发任务，持续后台运行',
    tag: 'Heartbeat',
  },
  {
    no: '03',
    icon: 'tool',
    title: '工具调用',
    desc: '通过自然语言实现Shell命令交互、文件操作、网络和接口调用',
    tag: 'Tools',
  },
  {
    no: '04',
    icon: 'database',
    title: '持久记忆',
    desc: '本地结构化长期记忆，智能沉淀用户习惯偏好，在重启后依然保留，且支持检索，实现越用越懂你',
    tag: 'Memory',
  },
  {
    no: '05',
    icon: 'message',
    title: '统一消息',
    desc: '通过统一网关接入飞书、微信等IM平台',
    tag: 'Channel',
  },
  {
    no: '06',
    icon: 'control',
    title: '真实世界I/O ',
    desc: 'GPIO、传感器、执行器——你的AI 可以读取数据，并且操控IoT设备，完整打通物理世界输入输出',
    tag: 'GPIO + Sensors + Actuators',
  },
]

export const demoCards = [
  {
    title: '本地结构化长期记忆，智能沉淀用户习惯偏好',
    desc: '记住用户生日，本地保存，设备重启后记忆不丢失，越用越懂你',
    video: demoVideos.skillExtension,
  },
  {
    title: '聊天对话即可定义设备行为',
    desc: '通过自然语言描述需求，即可驱动LED矩阵灯，实现不同动态效果',
    video: demoVideos.memory,
  },
  {
    title: '场景化技能灵活扩展',
    desc: '根据业务场景组合技能，如MiFi智能选网。开放技能扩展生态，支持设备能力封装复用、自定义场景技能开发与发布管理',
    video: demoVideos.chatDeviceBehavior,
  },
]

export const hardwareCards = [
  ['UniRTOS', 'Pico 开发板', '适合轻量端侧 Agent 验证和串口调试。'],
  ['UniRTOS', 'QuecDuino 开发板', '适合蜂窝网络、传感器接入和设备动作验证。'],
  [
    'Linux',
    'Quectel Pi H1 Linux 开发板',
    '适合 Dashboard、CLI、飞书和微信通道验证。',
  ],
]

export const flashSteps = [
  ['硬件', '选择硬件', 'ESP32-S3、T5AI、Raspberry Pi 或 Linux'],
  ['连接', '连接设备', '请求串口权限并识别芯片'],
  ['授权', '校验授权', '授权码有效后开放固件烧录'],
  ['写入', '写入固件', '展示进度、日志、错误恢复建议'],
  ['在线', 'Agent 在线', '完成校验并重启进入运行状态'],
]

export const authRecords = [
  ['UNI-2026-EDGE-DEMO', 'UC-ESP32S3-8A21', '有效', '2026-12-31', '12'],
  ['UNI-2026-T5AI-LAB', 'UC-T5AI-2D81', '有效', '2026-09-30', '6'],
  ['UNI-2026-RPI-TEST', 'UC-RPI5-91AF', '待验证', '2026-08-15', '3'],
]

export const docSections = [
  {
    id: 'quick',
    label: '快速上手',
    title: '快速开始',
    desc: '面向首次使用者，目标是在最短路径里跑通一块设备。',
    items: [
      ['准备', '准备开发板', '确认支持硬件、数据线、驱动和浏览器环境。'],
      [
        '授权',
        '申请授权码',
        '填写联系人、设备 SN 和使用场景，自动获取授权码。',
      ],
      ['烧录', '首次在线烧录', '连接串口，选择固件，完成写入和校验。'],
    ],
  },
  {
    id: 'guide',
    label: '日常使用',
    title: '使用指南',
    desc: '面向日常使用者，覆盖配置、升级、调试和故障处理。',
    soft: true,
    items: [
      ['Firmware', '固件版本管理', '如何选择稳定版、Demo 版和实验版固件。'],
      ['Skill', '技能配置', '启用家居、办公、出行等技能，并配置权限。'],
      ['Trouble', '故障排查', '设备无法识别、烧录失败、授权码无效的处理路径。'],
    ],
  },
  {
    id: 'reference',
    label: '开发扩展',
    title: '开发参考',
    desc: '面向开发者，提供接口、协议、适配层和扩展示例。',
    items: [
      ['Tools', '工具调用', 'Shell、文件、网络与设备接口的调用约定。'],
      ['SDK', 'Skill SDK', '自定义 Skill 的目录结构、权限声明和发布流程。'],
      ['HAL', '硬件适配层', '新增开发板、传感器和执行器适配的接口约定。'],
    ],
  },
]

export const docDownloads = [
  {
    name: 'uniclaw_Linux.zip',
    title: 'Linux 运行包',
    type: '运行资源',
    badge: 'Linux',
    desc: '适用于 Quectel Pi H1 Linux 环境部署。',
    url: apiAsset('/api/v1/aide/guide/document?filename=uniclaw_Linux.zip'),
    available: true,
  },
  {
    name: 'uniclaw_RTOS.zip',
    title: 'UniRTOS 固件包',
    type: '固件资源',
    badge: 'RTOS',
    desc: '适用于 Pico、QuecDuino 等 UniRTOS 开发板固件部署。',
    url: apiAsset('/api/v1/aide/guide/document?filename=uniclaw_RTOS.zip'),
    available: true,
  },
  {
    name: 'platform-tools.zip',
    title: 'platform-tools',
    type: '工具下载',
    badge: 'ADB',
    desc: '用于电脑侧通过 ADB 连接 Quectel Pi H1，并完成文件传输与设备调试。',
    url: apiAsset('/api/v1/aide/guide/document?filename=platform-tools.zip'),
    available: true,
  },
  {
    name: 'qflash',
    title: 'QFlash',
    type: '工具下载',
    badge: 'Flash',
    desc: '用于 UniRTOS 固件烧录，进入 Quectel 下载页获取 QFlash 工具。',
    url: 'https://www.quectel.com.cn/download/qflash_v8-0_cn',
    actionText: '前往下载',
    available: true,
  },
]

export const onlineDocs = [
  {
    id: 'quick-start',
    label: '快速开始',
    source: '快速入门.md',
    nav: '环境准备、启动与配置',
    title: 'UniClaw 快速入门',
    desc: '从设备准备、运行程序到完成首次对话，帮助新用户快速跑通 Linux 与 UniRTOS 平台。',
    meta: ['Linux', 'UniRTOS', 'Dashboard', 'CLI'],
    image: docImages.dashboardChat,
    sections: [
      {
        heading: 'UniClaw 是什么',
        body: [
          'UniClaw 是面向嵌入式设备打造的轻量级 AI Agent，可在资源受限的 Linux、UniRTOS 终端设备上部署运行，支持自然语言交互、工具调用、多消息通道与持久化记忆完整能力，为硬件终端提供本地Agent能力。',
        ],
        bullets: [
          '支持 Quectel、千问、DeepSeek、豆包、MiniMax、Kimi、OpenAI 等模型',
          '支持 CLI、Web Dashboard、飞书、微信、WebSocket 与语音通道',
          '支持网络搜索、Shell 命令、文件操作和本地长期记忆',
        ],
      },
      {
        heading: '选择使用平台',
        body: [
          'UniClaw 在 Quectel Pi 和 UniRTOS 上是两种不同的使用方式。先选择你的硬件平台，再进入对应文档完成部署、烧录和验证。',
        ],
        links: [
          {
            label: 'Quectel Pi',
            desc: '适用于 Quectel Pi 系列开发板，当前支持 Quectel Pi H1。通过 ADB 连接设备，安装运行依赖并部署 UniClaw，随后使用 CLI 或 Dashboard 完成 Agent 功能验证。',
            docId: 'pi-h1-guide',
          },
          {
            label: 'UniRTOS',
            desc: '适用于基于 UniRTOS 的嵌入式设备开发，当前支持 EG800Z 系列模组。通过 QFlash 烧录 UniRTOS 固件后，使用串口工具完成相关参数配置及功能验证。',
            docId: 'unirtos-guide',
          },
        ],
      },
      {
        heading: '下一步操作',
        body: [
          '完成平台选择后，可以进入应用开发指南理解 Agent、通道和角色文件，也可以查看资源包、命令参考和问题排查信息。',
        ],
        links: [
          {
            label: '应用开发指南',
            desc: '了解 Agent Loop、角色文件、消息通道、模型接入和扩展场景。',
            docId: 'app-guide',
          },
          {
            label: '资源下载',
            desc: '查看 Linux 运行包、UniRTOS 固件包和上手辅助资料。',
            docId: 'downloads',
          },
        ],
      },
    ],
  },
  {
    id: 'pi-h1-guide',
    label: 'Quectel Pi',
    source: '一键烧录适配.md',
    nav: 'Quectel Pi H1 开发板环境搭建',
    title: 'Quectel Pi',
    desc: '适用于 Quectel Pi 系列设备。以下将以 Quectel Pi H1 开发板为例，介绍如何通过 ADB 连接设备、安装运行依赖、部署 UniClaw 运行包，并使用 CLI 或 Dashboard 完成功能验证。',
    meta: ['Linux', 'ADB', 'Dashboard', 'CLI'],
    image: docImages.networkCheck,
    sections: [
      {
        heading: '平台官方文档',
        body: [
          '点击下方链接查看 Quectel Pi H1 系统使用、远程访问和开发板资料。',
        ],
        links: [
          {
            label: 'Quectel Pi 文档',
            desc: '查看 Quectel Pi 开发板、系统使用与远程访问等官方资料。',
            href: 'https://www.quectel.com.cn/quectel-pi/documentation-center',
          },
        ],
      },
      {
        heading: 'Quectel Pi H1 连接准备',
        body: [
          '使用 USB 转 Type-C 数据线连接电脑与 Quectel Pi H1，并下载 platform-tools 工具。Quectel Pi H1 默认使用 Debian 系统，进入设备后按 Linux 运行包方式部署 UniClaw。',
        ],
        bullets: [
          '打开 platform-tools 文件夹，在路径栏输入 cmd 启动终端',
          '使用 adb devices 确认设备连接',
          '使用 adb push 和 adb pull 在电脑与设备之间传输文件',
        ],
        inlineLinks: [
          {
            label: '下载 platform-tools',
            href: apiAsset(
              '/api/v1/aide/guide/document?filename=platform-tools.zip',
            ),
          },
        ],
        code: {
          label: 'ADB 常用命令',
          value:
            'adb devices\nadb push <电脑文件路径> <设备存放路径>\nadb pull <设备文件路径> <电脑存放路径>',
        },
        image: docImages.adbTerminal,
        caption: '在 platform-tools 目录路径栏输入 cmd，可直接打开 ADB 终端',
      },
      {
        heading: '安装前置依赖',
        body: [
          '进入设备终端后先确认网络可用，再更新软件源并安装编译工具链与运行库。',
        ],
        code: {
          label: '依赖安装',
          value:
            'ping www.baidu.com\nsudo apt update\nsudo apt install -y build-essential cmake\nsudo apt install libasound2-dev libcjson-dev libwebsockets-dev libcurl4-openssl-dev',
        },
        image: docImages.networkCheck,
        caption: '网络连通性检查示例',
      },
      {
        heading: '部署运行包',
        body: [
          '把 uniclaw_Linux.zip 解压到设备目录，进入 UniClaw 目录后添加执行权限并启动程序。',
        ],
        code: {
          label: '运行命令',
          value: 'cd uniclaw\nchmod +x uniclaw\n./uniclaw',
        },
      },
      {
        heading: '运行程序并配置密钥',
        body: [
          '启动后在 uniclaw 提示符中配置大模型、语音和飞书相关密钥。保存配置后重新运行即可进入对话。',
        ],
        code: {
          label: '运行和配置',
          value:
            'uniclaw> config set llm.provider qwen\nuniclaw> config set llm.model qwen-plus\nuniclaw> config set llm.api_key sk-你的密钥\nuniclaw> config set channels.voice.coze_api_key 你的coze密钥\nuniclaw> config set channels.feishu.app_id 你的飞书app_id\nuniclaw> config set channels.feishu.app_secret 你的飞书密钥\nuniclaw> config save',
        },
        images: [
          {
            src: docImages.cliChat,
            caption:
              '配置完成后重新运行 ./uniclaw，可在 CLI 中直接与 Agent 对话',
          },
          {
            src: docImages.cliConfig,
            caption: '配置命令可用于设置大模型、语音和飞书通道相关参数',
          },
        ],
      },
      {
        heading: 'Dashboard 验证',
        body: [
          'UniClaw 自带网页聊天和配置界面。启动程序后，在浏览器访问设备的 18790 端口即可使用。',
        ],
        code: {
          label: '访问地址',
          value: 'http://localhost:18790\nhttp://<设备IP>:18790',
        },
        image: docImages.dashboardConfig,
        caption: 'Dashboard 配置页面支持在线修改 API Key 与通道参数',
      },
    ],
  },
  {
    id: 'unirtos-guide',
    label: 'UniRTOS',
    source: '一键烧录适配.md',
    nav: 'Pico 开发板环境搭建',
    title: 'UniRTOS',
    desc: '适用于基于 UniRTOS 的设备开发。以下将以 Pico 开发板为例，介绍如何烧录 UniClaw 固件，并完成设备配置、联网验证和首次对话体验。',
    meta: ['UniRTOS', 'QFlash', '串口', '固件'],
    sections: [
      {
        heading: '平台官方文档',
        body: ['点击下方链接查看 UniRTOS 软件资料、开发工具和系统能力。'],
        links: [
          {
            label: 'UniRTOS 文档',
            desc: '查看 UniRTOS 软件资料、开发工具和系统能力等官方内容。',
            href: 'https://www.quectel.com.cn/unirtos/software',
          },
        ],
      },
      {
        heading: 'UniRTOS 固件烧录',
        body: [
          'UniRTOS 以固件形式适配 UniClaw。使用 QFlash 加载固件包，让设备进入下载模式后选择对应 COM 口开始烧录。',
        ],
        bullets: [
          '打开 QFlash 并点击 Load FW Files',
          '选择工程 release 目录下的 hbinpkg 文件',
          '短接 BOOT 测试点让设备进入下载模式',
          '在设备管理器确认 Quectel QDLoader Port 的 COM 号',
          '在 QFlash 选择 COM 口并点击 Start，等待 PASS',
        ],
        inlineLinks: [
          {
            label: '前往 QFlash 下载页',
            href: 'https://www.quectel.com.cn/download/qflash_v8-0_cn',
          },
        ],
        images: [
          {
            src: docImages.qflashOpen,
            caption: '打开 QFlash 工具，准备加载 UniRTOS 固件包',
          },
          {
            src: docImages.qflashLoadFirmware,
            caption: '点击 Load FW Files 选择待烧录固件',
          },
          {
            src: docImages.qflashFirmwarePackage,
            caption: '选择工程 qos_build/release 目录下的 .hbinpkg 文件',
          },
          {
            src: docImages.qflashBootMode,
            caption: '按开发板对应硬件说明短接 BOOT 测试点，使设备进入下载模式（图示为正面 5V 与 BOOT）',
          },
          {
            src: docImages.qflashComPort,
            caption: '在设备管理器中确认 Quectel QDLoader Port 对应的 COM 号',
          },
          {
            src: docImages.qflashStartPass,
            caption:
              '在 QFlash 选择 COM 口并点击 Start，等待进度完成并显示 PASS',
          },
        ],
      },
      {
        heading: '烧录成功校验',
        body: [
          '烧录完成后打开 QCOM，选择 AT 口并输入 AT。设备回复 OK 表示固件可正常运行。',
        ],
        images: [
          {
            src: docImages.qflashAtCheck,
            caption: 'QCOM 中选择 AT 口并输入 AT，回复 OK 表示固件烧录成功',
          },
        ],
      },
      {
        heading: '首次对话验证',
        body: [
          '完成模型参数配置后，通过串口发送对话内容。如果设备能返回模型回复，说明固件、网络和模型 API 已经连通。',
        ],
        table: [
          ['检查项', '通过标准'],
          ['固件烧录', 'QFlash 显示 PASS'],
          ['AT 口校验', 'QCOM 输入 AT 后返回 OK'],
          ['串口配置', '配置命令能够正常回显并保存'],
          ['模型连通', '发送“你好”后收到模型回复'],
        ],
      },
    ],
  },
  {
    id: 'downloads',
    label: '资源下载',
    source: '资源下载',
    nav: '运行包、固件包与工具',
    title: 'UniClaw 资源下载',
    desc: '集中管理 Quectel Pi H1 运行包、UniRTOS 固件包和连接、烧录所需工具，并提供正式下载入口。',
    meta: ['下载资源', '运行包', '固件包', '工具'],
    sections: [
      {
        heading: '资源下载',
        body: [
          '在这里获取 UniClaw Linux 运行包、UniRTOS 固件包以及连接、烧录所需工具；阅读 Quectel Pi H1 或 UniRTOS 指南时，也可以从对应步骤快速跳转到相关资源。',
        ],
        downloads: true,
      },
    ],
  },
  {
    id: 'faq',
    label: 'FAQ',
    source: 'FAQ',
    nav: 'CLI 命令与问题排查',
    title: 'FAQ',
    desc: '汇总 UniClaw 常用 CLI 命令和常见问题处理方式，便于部署、配置和验证时快速查阅。',
    meta: ['CLI', 'FAQ', '排查'],
    sections: [
      {
        heading: '常用 CLI 命令',
        table: [
          ['命令', '用途'],
          ['help', '查看所有可用命令'],
          ['config get llm.model', '查看某个配置项'],
          ['config show', '查看当前配置'],
          ['config set <key> <value>', '修改配置项'],
          ['config save', '保存配置到文件'],
          ['config reload', '重新加载配置文件'],
        ],
      },
      {
        heading: '常见问题',
        table: [
          ['问题', '处理方式'],
          [
            '启动后提示 connection failed 或 API error',
            '检查 data/config.json 中的 api_key、网络连通性，以及模型账号余额或额度',
          ],
          [
            '如何查看设备 IP 地址',
            '在 Linux 终端执行 ip addr show | grep "inet "',
          ],
          [
            'Dashboard 无法访问',
            '确认 UniClaw 进程仍在运行，并检查设备 IP、18790 端口和局域网连通性',
          ],
        ],
      },
    ],
  },
  {
    id: 'app-guide',
    label: '应用开发指南',
    source: '应用开发指南.md',
    nav: 'Agent、通道与角色文件',
    title: '应用开发指南',
    desc: '理解 UniClaw 的运行时目录、Agent Loop、角色文件、通道配置和大模型接入方式。',
    meta: ['Agent Loop', 'Channel', 'LLM', 'Memory'],
    image: docImages.architecture,
    sections: [
      {
        heading: '运行时目录结构',
        body: [
          'UniClaw 运行时由主程序和 data 目录组成，配置、角色文件、记忆、会话和扩展能力都放在 data 下。',
        ],
        code: {
          label: '目录结构',
          value:
            'uniclaw/\n  uniclaw\n  data/\n    config.json\n    AGENTS.md\n    SOUL.md\n    USER.md\n    TOOLS.md\n    memory/MEMORY.md\n    sessions/\n    skills/',
        },
      },
      {
        heading: '整体工作流程',
        tocLevel: 2,
        body: [
          'UniClaw 的运行时核心遵循“感知、思考、行动”的 Agent Loop 模式。用户从任意通道发起消息后，系统会组装上下文、调用大模型、执行必要工具，并把最终回复分发回原通道。',
        ],
        bullets: [
          '加载 SOUL、USER、TOOLS、AGENTS、memory 和会话历史',
          '把上下文和用户消息发送到大模型 API',
          '按模型请求执行工具调用，并把结果回传模型',
          '将最终回复发送到 CLI、Dashboard、飞书、微信等通道',
        ],
        image: docImages.architecture,
        caption: 'UniClaw 架构与通道、模型、平台之间的关系',
      },
      {
        heading: '配置优先级与数据流向',
        tocLevel: 2,
        body: [
          'UniClaw 的配置按环境变量、config.json、编译默认值的顺序生效。环境变量适合临时覆盖和 CI/CD 场景，config.json 适合通过 config set 与 config save 做长期保存。',
          '所有通道共享同一个 Agent Loop。用户输入会先进入通道接收层，再通过消息总线进入 Agent，必要时调用工具，最后把回复分发回对应通道。',
        ],
        bullets: [
          '环境变量使用 UC_ 前缀，优先级最高',
          'config.json 保存 LLM、通道、工具等运行配置',
          '编译默认值用于兜底，保证基础能力可启动',
        ],
        code: {
          label: '配置优先级与数据流',
          value:
            '环境变量 > config.json > 编译默认值\n\n用户输入 -> 通道接收 -> 消息总线 -> Agent Loop -> LLM API\n                                      -> 工具调用 -> Agent 回复 -> 通道发送',
        },
      },
      {
        heading: '角色定义文件',
        body: [
          'Agent 的行为由 data 目录下的 Markdown 文件共同决定，适合用来定义人设、用户画像、设备接口和行为边界。',
        ],
        table: [
          ['文件', '作用'],
          ['SOUL.md', '核心人设、身份、性格和边界'],
          ['USER.md', '用户画像、偏好和技术水平'],
          ['TOOLS.md', '可用设备、接口和安全注意事项'],
          ['AGENTS.md', '启动顺序、交互规则和工具策略'],
          ['MEMORY.md', '长期记忆和稳定经验'],
        ],
      },
      {
        heading: 'SOUL.md 示例',
        tocLevel: 2,
        body: [
          'SOUL.md 是 Agent 的性格文件，用于定义身份、沟通方式、价值观和行为边界。适合放置长期稳定的人设规则。',
        ],
        code: {
          label: '专业技术助手示例',
          value:
            '# SOUL.md\nI am a professional technical assistant.\nI provide accurate, concise, and actionable technical guidance.\n\n## Core Identity\n- Precision and clarity define my communication\n- I prioritize correctness over friendliness\n\n## Communication Style\n- Use technical terminology when appropriate\n- Provide code examples and commands\n- Always include error handling considerations\n\n## Boundaries\n- I do not speculate when I lack information\n- I clearly state limitations and uncertainties',
        },
      },
      {
        heading: 'USER.md 示例',
        tocLevel: 2,
        body: [
          'USER.md 帮助 Agent 理解用户画像、偏好和技术背景。它可以手动预设，也可以随着长期记忆逐步完善。',
        ],
        code: {
          label: '用户画像示例',
          value:
            '# USER.md\nThis file describes the person I am chatting with.\n\n## Basic Info\n- Preferred name: 小明\n- Timezone: Asia/Shanghai\n- Language: Chinese (Simplified)\n\n## Communication Preferences\n- Preferred tone: casual\n- Response length: concise\n- Sensitive topics: avoid politics\n\n## Technical Level\n- Programming: intermediate (Python, C)\n- Familiar with Linux command line\n- IoT hobbyist\n\n## Notes\n> Prefers step-by-step explanations for complex tasks.',
        },
      },
      {
        heading: 'TOOLS.md 示例',
        tocLevel: 2,
        body: [
          'TOOLS.md 告诉 Agent 当前设备有哪些接口、可以执行哪些动作，以及真实设备控制时需要遵守哪些安全限制。',
        ],
        code: {
          label: '设备接口描述示例',
          value:
            '# TOOLS.md\nThis file documents available tools and device interfaces.\n\n## Supported Device Actions\n- Light on / off (via GPIO pin 17)\n- Fan speed control (via PWM pin 18)\n- Temperature reading (via I2C sensor at 0x48)\n- Motor rotate / stop (via RS485 command)\n\n## Interfaces\n- GPIO: pins 17, 18, 27 available\n- Serial: /dev/ttyUSB0 at 9600 baud\n- I2C: bus 1, devices at 0x48, 0x50\n- Network APIs: local REST endpoints\n\n## Safety Notes\n- Always check device state before action\n- Log every control operation\n- Motor operations require 2-second cooldown',
        },
      },
      {
        heading: 'AGENTS.md 示例',
        tocLevel: 2,
        body: [
          'AGENTS.md 规定 Agent 的行为策略、技能调用方式和工具使用规范。对真实世界动作，建议明确要求必须通过工具调用执行。',
        ],
        code: {
          label: '行为规则示例',
          value:
            '# AGENTS.md\nThis file defines how I act as an agent.\n\n## Startup\nLoad, in order:\n1. data/SOUL.md\n2. data/USER.md\n3. data/TOOLS.md\n4. data/memory/MEMORY.md\n\n## Interaction Rules\n- Lead with emotional awareness\n- Match the user tone gently\n- Never escalate emotional intensity\n\n## Skills\n- Skills are specialized instruction files stored in ./data/skills/\n- When a task matches a skill, read the full skill file for detailed instructions\n- You can create new skills using write_file to ./data/skills/<name>.md\n\n## Tool Usage\n- MANDATORY: When performing any real-world action, you MUST use a tool call\n- Never claim an action was performed without actually calling a tool\n- If you have a matching skill with shell commands, call the shell tool with the exact command',
        },
      },
      {
        heading: 'MEMORY.md 示例',
        tocLevel: 2,
        body: [
          '长期记忆存储在 data/memory/MEMORY.md 中。Agent 会把稳定、有长期价值的信息写入记忆，也可以由开发者手动预设。',
        ],
        code: {
          label: '长期记忆示例',
          value:
            '# MEMORY.md\nThis is my long-term memory.\nOnly meaningful, stable insights are stored here.\n\n## Emotional Patterns\n- User appreciates being heard\n- User prefers calm explanations\n\n## Established Practices\n- Validate emotions before advice\n- Use Chinese for casual conversation\n\n## User Facts\n- Lives in Shanghai\n- Has a Raspberry Pi 4 running UniClaw\n- Interested in smart home automation',
        },
      },
      {
        heading: '消息通道配置',
        body: [
          '所有通道共享同一个 Agent 内核，并通过 session 机制隔离上下文。CLI 适合本地调试，Dashboard 适合局域网访问，飞书和微信适合团队协作与移动端触达。',
        ],
        table: [
          ['通道', '适用场景', '配置复杂度'],
          ['CLI', '本地调试与首次配置', '低'],
          ['Dashboard', '浏览器聊天与配置管理', '低'],
          ['WebSocket', '自定义客户端接入', '低'],
          ['飞书', '企业群聊和私聊机器人', '中'],
          ['微信', '微信生态消息入口与微信客户端协作', '中'],
          ['语音', 'ASR、TTS 和语音唤醒', '高'],
        ],
      },
      {
        heading: 'CLI 通道',
        tocLevel: 2,
        body: [
          'CLI 是默认通道，启动 UniClaw 即可直接使用，无需额外配置。它适合本地开发、首次配置系统，以及快速测试 Agent 行为。',
        ],
        code: {
          label: '启动与对话示例',
          value: './uniclaw\n\nuniclaw> 你好，帮我查一下今天的天气',
        },
      },
      {
        heading: 'Dashboard 通道',
        tocLevel: 2,
        body: [
          'Dashboard 提供浏览器端聊天界面和配置管理页面。启用后，局域网用户可以访问设备 IP 的 18790 端口进行对话和配置。',
          'Dashboard 基于内嵌 HTTP 服务实现，不需要额外安装 Nginx 或 Apache。',
        ],
        code: {
          label: '启用 Dashboard',
          value:
            'uniclaw> config set channels.dashboard.enabled true\nuniclaw> config set channels.dashboard.port 18790\nuniclaw> config save\n\nhttp://<设备IP>:18790',
        },
        image: docImages.dashboardConfig,
        caption: 'Dashboard 配置页面可在线查看和修改配置项',
      },
      {
        heading: 'WebSocket 接入',
        tocLevel: 2,
        body: [
          'WebSocket 通道提供标准 JSON 消息接口，适合自定义 Web 应用、Python/Node.js 客户端或其他业务系统接入。',
          '每条消息可以携带 session_id，不同客户端会话互相隔离。',
        ],
        code: {
          label: '启用与消息格式',
          value:
            'uniclaw> config set channels.websocket.enabled true\nuniclaw> config set channels.websocket.port 18789\nuniclaw> config save\n\n发送：{"type":"message","content":"你好","session_id":"my-session-001"}\n接收：{"type":"response","content":"回复内容","session_id":"my-session-001"}',
        },
      },
      {
        heading: '飞书、微信与语音通道',
        tocLevel: 2,
        body: [
          '飞书和微信通道让 Agent 进入企业协作、社群或移动端消息场景。飞书推荐使用长连接事件订阅，无需公网 IP 或回调域名；微信侧可按后续项目接入方式配置消息入口。',
          '语音通道提供 ASR、TTS、VAD 和关键词唤醒能力，设备需要连接麦克风与扬声器，并安装 ALSA 音频驱动。',
        ],
        bullets: [
          '飞书应用需要 App ID、App Secret，并开启收发消息相关权限',
          '飞书事件订阅选择长连接模式，并订阅 im.message.receive_v1',
          '微信通道按项目提供的应用凭证和消息回调配置接入',
          '语音通道需要配置 Coze API Key，并保证 libasound2 依赖可用',
        ],
        code: {
          label: '通道配置示例',
          value:
            'uniclaw> config set channels.feishu.enabled true\nuniclaw> config set channels.feishu.app_id cli_xxxxxxxxxxxxxx\nuniclaw> config set channels.feishu.app_secret xxxxxxxxxxxxxxxxxxxxx\nuniclaw> config set channels.voice.enabled true\nuniclaw> config set channels.voice.coze.api_key pat_xxxxxxxxxx\nuniclaw> config save',
        },
      },
      {
        heading: '多通道共存',
        tocLevel: 2,
        body: [
          'CLI、Dashboard、WebSocket、飞书、微信和语音通道可以同时启用。不同通道维护独立 session，互不污染上下文，但共享同一个 Agent 能力和记忆体系。',
        ],
        code: {
          label: '典型多通道配置',
          value:
            'uniclaw> config set channels.dashboard.enabled true\nuniclaw> config set channels.dashboard.port 18790\nuniclaw> config set channels.websocket.enabled true\nuniclaw> config set channels.websocket.port 18789\nuniclaw> config set channels.feishu.enabled true\nuniclaw> config set channels.feishu.app_id cli_xxxxx\nuniclaw> config set channels.feishu.app_secret xxxxx\nuniclaw> config save',
        },
      },
      {
        heading: '模型供应商与参数',
        body: [
          'UniClaw 通过统一 LLM Proxy 层切换模型。任何兼容 OpenAI API 格式的模型都可以通过 provider 和 api_url 接入。',
          'max_tokens 控制单次回复最大长度：1024 适合短指令，4096 适合一般对话，8192 适合长文与代码生成。',
        ],
        code: {
          label: '通用配置格式',
          value:
            'uniclaw> config set llm.provider <提供商>\nuniclaw> config set llm.model <模型名称>\nuniclaw> config set llm.api_key <你的API密钥>\nuniclaw> config set llm.api_url <API地址>\nuniclaw> config set llm.max_tokens 4096\nuniclaw> config save',
        },
        table: [
          ['提供商', 'provider 值', '推荐模型', '获取地址'],
          ['Quectel', 'quectel', 'gpt-5.4', '联系 Quectel 获取'],
          [
            '通义千问',
            'qwen',
            'qwen-plus / qwen-max',
            'dashscope.console.aliyun.com',
          ],
          ['DeepSeek', 'deepseek', 'deepseek-chat', 'platform.deepseek.com'],
          ['豆包', 'doubao', 'doubao-pro-32k', 'console.volcengine.com'],
          ['智谱 AI', 'GLM', 'glm-4', 'open.bigmodel.cn'],
          ['MiniMax', 'minimax', 'abab6.5-chat', 'minimaxi.com'],
          ['小米Mimo', 'mimo', 'mimo-chat', 'api.mimo.ai'],
          ['Kimi', 'kimi', 'moonshot-v1-8k', 'platform.moonshot.cn'],
          ['OpenAI', 'openai', 'gpt-4o / gpt-4o-mini', 'platform.openai.com'],
          [
            'OpenAI 兼容服务',
            'openai',
            '按服务端模型命名',
            'Ollama / vLLM / OpenRouter / SiliconFlow 等',
          ],
        ],
      },
      {
        heading: 'Quectel 模型配置',
        tocLevel: 2,
        body: [
          '使用 Quectel 提供的模型服务时，按项目分配的模型名称、API Key 和 API 地址填写即可。',
        ],
        code: {
          label: 'Quectel 配置示例',
          value:
            'uniclaw> config set llm.provider quectel\nuniclaw> config set llm.model gpt-5.4\nuniclaw> config set llm.api_key sk-xxxxxxxxxxxxxxxx\nuniclaw> config set llm.api_url <Quectel 提供的 API 地址>\nuniclaw> config save',
        },
      },
      {
        heading: '通义千问配置',
        tocLevel: 2,
        body: [
          '国内用户可以优先使用通义千问。配置 provider、model、api_key 和兼容 OpenAI 格式的 API 地址后保存即可。',
        ],
        code: {
          label: 'Qwen 配置示例',
          value:
            'uniclaw> config set llm.provider qwen\nuniclaw> config set llm.model qwen-plus\nuniclaw> config set llm.api_key sk-xxxxxxxxxxxxxxxx\nuniclaw> config set llm.api_url https://dashscope.aliyuncs.com/compatible-mode/v1/chat/completions\nuniclaw> config save',
        },
      },
      {
        heading: 'DeepSeek 配置',
        tocLevel: 2,
        body: [
          'DeepSeek 同样按兼容 OpenAI API 的方式接入，只需切换 provider、model 和 api_url。',
        ],
        code: {
          label: 'DeepSeek 配置示例',
          value:
            'uniclaw> config set llm.provider deepseek\nuniclaw> config set llm.model deepseek-chat\nuniclaw> config set llm.api_key sk-xxxxxxxxxxxxxxxx\nuniclaw> config set llm.api_url https://api.deepseek.com/v1/chat/completions\nuniclaw> config save',
        },
      },
      {
        heading: '豆包配置',
        tocLevel: 2,
        body: [
          '豆包模型通过火山引擎控制台获取 API Key、模型名称和兼容 OpenAI API 的调用地址。',
        ],
        code: {
          label: '豆包配置示例',
          value:
            'uniclaw> config set llm.provider doubao\nuniclaw> config set llm.model doubao-pro-32k\nuniclaw> config set llm.api_key sk-xxxxxxxxxxxxxxxx\nuniclaw> config set llm.api_url <豆包兼容 OpenAI API 地址>\nuniclaw> config save',
        },
      },
      {
        heading: '智谱 AI 配置',
        tocLevel: 2,
        body: [
          '智谱 AI 使用 GLM 系列模型时，provider 使用 GLM，并填写控制台提供的模型、密钥和兼容接口地址。',
        ],
        code: {
          label: '智谱 AI 配置示例',
          value:
            'uniclaw> config set llm.provider GLM\nuniclaw> config set llm.model glm-4\nuniclaw> config set llm.api_key sk-xxxxxxxxxxxxxxxx\nuniclaw> config set llm.api_url <智谱 AI 兼容 OpenAI API 地址>\nuniclaw> config save',
        },
      },
      {
        heading: 'MiniMax 配置',
        tocLevel: 2,
        body: [
          'MiniMax 模型接入时，使用 minimax provider，并填写 MiniMax 平台分配的模型名称、密钥和接口地址。',
        ],
        code: {
          label: 'MiniMax 配置示例',
          value:
            'uniclaw> config set llm.provider minimax\nuniclaw> config set llm.model abab6.5-chat\nuniclaw> config set llm.api_key sk-xxxxxxxxxxxxxxxx\nuniclaw> config set llm.api_url <MiniMax 兼容 OpenAI API 地址>\nuniclaw> config save',
        },
      },
      {
        heading: '小米Mimo配置',
        tocLevel: 2,
        body: [
          '小米Mimo模型接入时，使用 mimo provider，并填写小米Mimo平台分配的模型名称、密钥和接口地址。',
        ],
        code: {
          label: '小米Mimo配置示例',
          value:
            'uniclaw> config set llm.provider mimo\nuniclaw> config set llm.model mimo-chat\nuniclaw> config set llm.api_key sk-xxxxxxxxxxxxxxxxxxxxxxxx\nuniclaw> config set llm.api_url https://api.mimo.ai/v1/chat/completions\nuniclaw> config save',
        },
      },
      {
        heading: 'Kimi 配置',
        tocLevel: 2,
        body: [
          'Kimi 使用 Moonshot 平台模型，适合长上下文对话、文档理解和代码辅助场景。',
        ],
        code: {
          label: 'Kimi 配置示例',
          value:
            'uniclaw> config set llm.provider kimi\nuniclaw> config set llm.model moonshot-v1-8k\nuniclaw> config set llm.api_key sk-xxxxxxxxxxxxxxxx\nuniclaw> config set llm.api_url https://api.moonshot.cn/v1/chat/completions\nuniclaw> config save',
        },
      },
      {
        heading: 'OpenAI 配置',
        tocLevel: 2,
        body: [
          'OpenAI 使用 openai provider，适合接入 GPT 系列模型或其他同格式代理服务。',
        ],
        code: {
          label: 'OpenAI 配置示例',
          value:
            'uniclaw> config set llm.provider openai\nuniclaw> config set llm.model gpt-4o-mini\nuniclaw> config set llm.api_key sk-xxxxxxxxxxxxxxxx\nuniclaw> config set llm.api_url https://api.openai.com/v1/chat/completions\nuniclaw> config save',
        },
      },
      {
        heading: 'OpenAI 兼容模型配置',
        tocLevel: 2,
        body: [
          'Ollama、vLLM、OpenRouter、SiliconFlow 等兼容 OpenAI API 格式的服务，可以复用 openai provider，并把 api_url 指向对应服务地址。',
        ],
        code: {
          label: '兼容接口配置示例',
          value:
            'uniclaw> config set llm.provider openai\nuniclaw> config set llm.model <服务端模型名称>\nuniclaw> config set llm.api_key <服务端密钥或占位值>\nuniclaw> config set llm.api_url <兼容 OpenAI API 地址>\nuniclaw> config save',
        },
      },
      {
        heading: '模型配置验证',
        tocLevel: 2,
        body: [
          '配置完成后直接在 CLI 中发送一条消息，例如“你好”。如果收到正常回复，说明模型配置可用。',
          '如果出现错误，先用 config show 检查当前配置，再确认 API Key、API 地址、账号额度和网络连通性。',
        ],
        table: [
          ['错误', '含义'],
          ['401 Unauthorized', 'API 密钥不正确或无权限'],
          ['Connection refused', 'API 地址不可达或网络不通'],
          ['429 Too Many Requests', '额度耗尽或请求过快'],
        ],
      },
      {
        heading: '场景扩展',
        body: [
          '基于角色文件、工具调用和通道配置，可以把 UniClaw 扩展为设备控制、运维协作或 IoT 数据中枢。',
        ],
        table: [
          ['场景', '实现方式'],
          ['串口设备控制', '编写 shell 脚本，通过 /dev/ttyUSB0 发送指令'],
          ['HTTP 设备控制', '使用 curl 调用设备 REST API'],
          ['条件联动', '定时检测加条件判断，例如温度超过 30 度自动开风扇'],
          ['语音控制', '启用 Voice 通道，实现关键词唤醒与语音交互'],
          ['多设备协调', '在 Skill 中定义回家模式、离家模式等场景组合'],
        ],
      },
      {
        heading: '故障排查',
        tocLevel: 2,
        table: [
          ['问题', '排查方法'],
          ['Agent 不调用工具', '检查 AGENTS.md 是否定义工具调用规则'],
          [
            'Skill 未被匹配',
            '确认文件在 data/skills/ 下，并检查 When to use 描述',
          ],
          ['Shell 命令失败', '手动执行脚本并确认权限和路径'],
          ['设备无响应', '检查 GPIO、串口、接线和驱动状态'],
          ['API 报错', '检查 api_key、api_url、额度和网络连通性'],
          ['回复不符合预期', '调整 SOUL.md 或 Skill 中的指令描述'],
        ],
      },
    ],
  },
]
